/**
 * ============================================================================
 * MASTER ROUTES: Platform Administration Route Definitions
 * ============================================================================
 * Purpose:
 *   Defines routes and element mappings for Master Database admin screens.
 * ============================================================================
 */

import React from "react";
import { Route, Navigate } from "react-router-dom";

import UserManagement from "../master/pages/users/UserManagement";
import CreateUser from "../master/pages/users/CreateUser";
import RoleManagement from "../master/pages/roles/RoleManagement";
import DatabaseManagement from "../master/pages/databases/DatabaseManagement";
import OperatorManagement from "../master/pages/operators/OperatorManagement";
import MenuManagement from "../master/pages/menus/MenuManagement";
import CountryManagement from "../master/pages/countries/CountryManagement";
import LoginLogs from "../master/pages/logs/LoginLogs";
import PhoneNumberList from "../user/pages/phoneNumbers/PhoneNumberList";
import LedgerManagement from "../user/pages/ledgers/LedgerManagement";
import ApiDocumentation from "../user/pages/docs/ApiDocumentation";

export const masterRoutes = (
  <>
    <Route path="admin/users" element={<UserManagement />} />
    <Route path="admin/users/create" element={<CreateUser />} />
    <Route path="admin/users/edit/:id" element={<CreateUser />} />
    <Route path="admin/accounts" element={<Navigate to="/admin/users" replace />} />
    <Route path="admin/roles" element={<RoleManagement />} />
    <Route path="admin/databases" element={<DatabaseManagement />} />
    <Route path="admin/operators" element={<OperatorManagement />} />
    <Route path="admin/phone-numbers" element={<PhoneNumberList />} />
    <Route path="admin/menus" element={<MenuManagement />} />
    <Route path="admin/countries" element={<CountryManagement />} />
    <Route path="admin/login-logs" element={<LoginLogs />} />
    <Route path="admin/ledgers" element={<LedgerManagement />} />
    <Route path="admin/docs" element={<ApiDocumentation />} />
    <Route path="admin/api-docs" element={<ApiDocumentation />} />
  </>
);


export default masterRoutes;
